//include 4 
jQuery(function(){

        var privateFunctions = {
            getRandom: function(){
                var d = new Date();
                var t = d.getTime();
                return t + "" + Math.floor(Math.random() * 100);
            },
            initialize: function (elements) {
               if(!elements || elements.length == 0){
                    return;
               }
               elements.each(function(){
                    var element = $(this);
                    if(!element.hasClass("busted")){
                        var link = element.attr("href");
                        if(!!link){
                            var parser = document.createElement('a');
                            parser.href = link;

                            var d = new Date();
                            var t = d.getTime();
                            var random = 

                            parser.hash = "#" + privateFunctions.getRandom();
                            element.attr("href", parser.href);
                        }
                        element.addClass("busted");
                    }
               });
            }
        }
            
        window.pixelpoint.ppComponents.cacheBust = {
            init: privateFunctions.initialize
        };

        window.pixelpoint.ppComponents.cacheBust.init($("[data-cache-bust]"));

        });